  <div class="modal-header bg-success">
    <h4 class="modal-title">Nie pamiętasz hasła?</h4>
    <button type="button" tabindex="-1" class="close" (click)="zamknij()" data-dismiss="modal"
      aria-hidden="true">&times;</button>
  </div>
  <div class="modal-body" stop-event="touchend">
    <div [hidden]="!error" class="alert alert-danger">{{error}}</div>
    <form name="form" (submit)="renewPassword()" role="form">

      <div class="form-group">
        <label for="email">Adres email, na które zostało zarejestrowane konto:</label>
        <i class="fa fa-key"></i>
        <input type="email" name="email" id="email" class="form-control" [(ngModel)]="email" autocomplete="off" required
          #emailInput="ngModel" email />
        <div *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)" class="text-danger">
          <div *ngIf="emailInput.errors.required">
            Podaj adres email
          </div>
          <div *ngIf="emailInput.errors.email">
            Niepoprawny adres email
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" [disabled]="emailInput.invalid" class="btn btn-danger">Przypomnij hasło</button>
      </div>
    </form>


  </div>
